import type { SearchHistoryTopResult } from './useSearchHistory'
import type { SearchResult } from '~/utils/solr/search'
import { resolveSolrDocumentUrl } from '#shared/utils/solr'

/**
 * Track search results and adds them to search history. Watches for when results load and extracts the top result.
 *
 * @param context The history context to use.
 * @param searchTerm The current search term.
 * @param searchResults The current search results.
 * @param isLoading Whether the search results are currently loading.
 */
export function useSearchHistoryTracker(context: HistoryContext, searchTerm: MaybeRef<string>, searchResults: MaybeRef<SearchResult[] | null>, isLoading: MaybeRef<boolean>) {
  const { addSearchTermToHistory } = useSearchHistory(context)

  watch([searchTerm, searchResults, isLoading], useDebounceFn(([term, results, loading]) => {
    if (!term || loading || !results || results.length === 0) {
      return
    }

    const topDocument = results[0]
    if (!topDocument) {
      return
    }

    const topResult: SearchHistoryTopResult = {
      id: topDocument.id,
      title: topDocument.title || term || 'Uten tittel',
      nodeType: topDocument.nodeType,
      author: topDocument.author,
      publishedAt: topDocument.publishedAt,
      editionNumber: topDocument.editionNumber,
      url: resolveSolrDocumentUrl(topDocument, term),
    }

    addSearchTermToHistory(term, topResult)
  }, 1000))
}
